import type { AxiosInstance } from 'axios';
import type {
  ManifestCheck,
  ManifestCheckListResponse,
  ListQueryParams,
  ManifestCheckCreateRequest,
  ManifestCheckUpdateRequest,
  EntityId,
} from '@/types';

export const getManifestChecks = async (
  api: AxiosInstance,
  manifest_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<ManifestCheckListResponse> => {
  const resp = await api.get<ManifestCheckListResponse>(`/manifest/${manifest_id}/check`, {
    params: { limit, start_key, name } as ListQueryParams,
  });
  return resp.data;
};

export const getManifestCheck = async (
  api: AxiosInstance,
  manifest_id: EntityId,
  manifest_check_id: EntityId,
): Promise<ManifestCheck> => {
  const resp = await api.get<ManifestCheck>(
    `/manifest/${manifest_id}/check/${manifest_check_id}`,
  );
  return resp.data;
};

export const createManifestCheck = async (
  api: AxiosInstance,
  manifest_id: EntityId,
  values: ManifestCheckCreateRequest,
): Promise<ManifestCheck> => {
  const resp = await api.post<ManifestCheck>(`/manifest/${manifest_id}/check`, values);
  return resp.data;
};

export const updateManifestCheck = async (
  api: AxiosInstance,
  manifest_id: EntityId,
  manifest_check_id: EntityId,
  values: ManifestCheckUpdateRequest,
): Promise<ManifestCheck> => {
  const resp = await api.put<ManifestCheck>(
    `/manifest/${manifest_id}/check/${manifest_check_id}`,
    values,
  );
  return resp.data;
};

export const deleteManifestCheck = async (
  api: AxiosInstance,
  manifest_id: EntityId,
  manifest_check_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(
    `/manifest/${manifest_id}/check/${manifest_check_id}`,
  );
  return resp.data;
};

